export enum WallpaperCategory {
  All = 'all',
  System = 'system',
  Personal = 'personal'
}
